import { ChartTooltip } from "@similarweb/ui-components";
import type { ColumnDefinition } from "@similarweb/ui-components";

import type { TooltipRow } from "./types";
import { translate } from "app/filters/i18nFilter";

export const tooltipColumnDefinition: ColumnDefinition<TooltipRow>[] = [
    {
        get title() {
            return translate("common.domain");
        },
        key: "domain",
        selector: "domain",
        align: "left",
        size: "150px",
        render: ({ domain }: TooltipRow) => (
            <ChartTooltip.LabelCell
                label={domain.label}
                backgroundColor={domain.color}
            />
        ),
    },
    {
        get title() {
            return translate("common.value");
        },
        key: "value",
        selector: "value",
        align: "right",
        size: ChartTooltip.ValueCellDefaultwidth,
        render: ({ value }: TooltipRow) => <ChartTooltip.ValueCell value={value} />,
    },
    {
        get title() {
            return translate("common.tooltip.change");
        },
        key: "change",
        selector: "change",
        align: "right",
        size: ChartTooltip.ChangeCellDefaultWidth,
        render: ({ change }: TooltipRow) => {
            if (!change) {
                return <ChartTooltip.ValueCell value={""} />;
            }

            return (
                <ChartTooltip.ChangeCell
                    value={change.value}
                    isDecrease={change.isDecrease}
                />
            );
        },
    },
];
